<template>
  <div>
    <div class="productBanner"><Banner :classType="2" /></div>
    <Menu v-if="lang == 'zh'" />
    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>检测服务</h2>
      <p>TESTING SERVICE</p>
    </div>

    <div class="wrap">
      <div class="caree_list">
        <ul>
          <li
            class="wow animate__slideInUp"
            data-wow-delay=".2s"
            v-for="(item, idx) in jcList"
            :key="idx"
          >
            <div class="item flex-ac mgrid">
              <div class="item_pic mx12">
                <div class="bimg">
                  <img :src="item.PicUrl" alt="" width="100%" />
                </div>
              </div>
              <div class="item_info mx12">
                <div class="item_tit fb">{{ item.Title }}</div>
                <div class="item_cont">
                  {{ item.Summary }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="grey-bg useMG wow animate__slideInUp">
      <div class="wrap useBox">
        <div class="sec_type">
          <h3>{{ intro.Title }}</h3>
          <p>
            {{ intro.Summary }}
          </p>
        </div>
        <el-row :gutter="50">
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
          >
            <h2 class="useH2">{{ TestName1 }}</h2>
            <div class="tableBox">
              <el-table :data="TestItemInfos1">
                <el-table-column  v-for="(item2,index) in Names1" :key="index"
                :prop="'Item' + (index + 1)"
                  align="center"
                  :label="item2"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="usePageBox">
              <Pagination
                @pageChange="getTest1"
                :PagingInfo="PagingInfo1"
                v-if="showPage1"
              />
              <p v-else><br /><br /></p>
            </div>
          </el-col>
        </el-row>


        <el-row :gutter="50">
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
          >
            <h2 class="useH2">{{ TestName2 }}</h2>
            <div class="tableBox">
              <el-table :data="TestItemInfos2">
                <el-table-column  v-for="(item2,index) in Names2" :key="index"
                :prop="'Item' + (index + 1)"
                  align="center"
                  :label="item2"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="usePageBox">
              <Pagination
                @pageChange="getTest2"
                :PagingInfo="PagingInfo2"
                v-if="showPage2"
              />
              <p v-else><br /><br /></p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import Slide from "./Slide.vue";
import { WOW } from "wowjs";
import Pagination from "@/views/components/Pagenation";

export default {
  data() {
    return {
      type: this.$route.query.type || "",
      lang: this.$global.lang,
      tableData: [
        {
          one: "外观22",
          two: "GB/T 26752",
        },
        {
          one: "线密度",
          two: "GB/T3362 附录B",
        },
        {
          one: "拉伸强度",
          two: "GB/T3362",
        },
        {
          one: "拉伸弹性模量",
          two: "GB/T3362",
        },
        {
          one: "断裂伸长率",
          two: "GB/T3362",
        },
        {
          one: "密度",
          two: "GB/T 30019方法C",
        },
        {
          one: "浸润剂含量",
          two: "GB/T 29761 方法A",
        },
        {
          one: "灰分",
          two: "GB/T 26752 附录B",
        },
      ],
      tableData2: [
        {
          one: "拉伸强度",
          two: "ASTM D3039/D 3039M-17 ",
        },
        {
          one: "拉伸弹性模量",
          two: "ASTM D3039/D 3039M-17 ",
        },
        {
          one: "压缩强度",
          two: "ASTM D6641/D 6641M-16",
        },
        {
          one: "压缩弹性模量",
          two: "ASTM D6641/D 6641M-16",
        },
        {
          one: "弯曲强度",
          two: "ASTM D7264/D 7264M-15",
        },
        {
          one: "弯曲弹性模量",
          two: "ASTM D7264/D 7264M-15 ",
        },
        {
          one: "层间剪切强度",
          two: "ASTM D2344/D 2344M-16",
        },
      ],
      intro: {},
      newsList: [],
      PagingInfo: {},
      CertificateList: [],
      ContentInfos: [],
      onSlide: sessionStorage.getItem("useId") || 0,
      PicUrl: [],
      
      jcList: [],

      TestName1: '',
      Names1:[],
      TestItemInfos1: [],
      showPage1: false,
      PagingInfo1: {},

      TestName2: '',
      Names2:[],
      TestItemInfos2: [],
      showPage2: false,
      PagingInfo2: {},
    };
  },
  components: {
    Menu,
    Banner,
    NewsList,
    Slide,
    Pagination,
  },
  methods: {
    handleScroll2(type) {
      let note = this.$refs.note.offsetTop - 40;
      let threeD = this.$refs.three.offsetTop - 40;
      let meshine = navigator.userAgent;
      var element =
        meshine.indexOf("Weixin") == -1
          ? document.documentElement
          : document.body;
      element.scrollTop = type ? threeD : note;
    },
    getData1(page, type) {
      this.$api
        .jcList({
          Type: 2,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          
          const { TestProjectDesc, TestServiceInfos } = res.Value;
          this.jcList = TestServiceInfos;
          this.intro = TestProjectDesc;
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getData(page, type) {
      this.$api
        .fileList({
          Type: 2,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { FileInfos } = res.Value;
          this.newsList = FileInfos;

          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
    getTest1(page) {
      this.$api.GetTestingList({
    Type:1,
    CurrentPage: page,
    ItemsPerPage: 10,
  }).then((res) => {
    const { Names,PagingInfo,TestItemInfos,TestName } = res.Value;
    console.log(res, "+++++++0001111");
    this.TestName1 = TestName;
    this.Names1 = Names;
    this.TestItemInfos1 = TestItemInfos;
    this.PagingInfo1 = PagingInfo;
    if (PagingInfo.TotalPages >1) {
            this.showPage1 = true
          }
  });
    },

    getTest2(page) {
      this.$api.GetTestingList({
    Type:2,
    CurrentPage: page,
    ItemsPerPage: 10,
  }).then((res) => {
    const { Names,PagingInfo,TestItemInfos,TestName } = res.Value;

    this.TestName2 = TestName;
    this.Names2 = Names;
    this.TestItemInfos2 = TestItemInfos;
    this.PagingInfo2 = PagingInfo;
    if (PagingInfo.TotalPages >1) {
            this.showPage2 = true
          }
  });
},
    getUse() {
      this.$api.rearch({ Type: 2 }).then((res) => {
        const { ContentInfos } = res.Value;
        this.ContentInfos = ContentInfos;
      });
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        this.onSlide = this.$route.params.id;
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;

    this.getData1(1, "first");
    
    this.getTest1();
    this.getTest2();
    this.getUse();

  },
};
</script>

<style lang="scss">
.useMG {
  margin-top: 50px;
  padding-bottom: 50px;
}
.useBox {
  padding: 50px 0 0 0;
}
.useH2 {
  background-color: #f3f3f3;
  font-weight: 400;
  line-height: 55px;
  text-align: center;
  padding: 0 0 0 10px;
  border-bottom: 1px solid #ddd;
}
.tableBox {
  .el-table {
    margin-bottom: 0px;
    thead {
      color: #000;
    }
  }
  .el-table th.el-table__cell {
    background-color: #fff;
  }
}
.useImg {
  width: 100%;
}
.useDown {
  border: 1px solid #bfbfbf;
  line-height: 25px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.useSlideW {
  padding: 50px 0;
}
.sec_type {
  margin: 20px 0 35px;
  h3 {
    font-size: 20px;
    margin-bottom: 6px;
  }
  p {
    line-height: 1.3;
    font-size: 14px;
  }
}
/* 人才理念 */
.caree_list {
  padding-top: 25px;
  li {
    margin: 20px 0;
    .item {
      background: #f9f9f9;
    }
    .item_pic,
    .item_info {
      width: 50%;
    }
    .item_info {
      padding: 0 30px;
      .item_tit {
        margin-bottom: 15px;
        font-size: 18px;
        color: #333;
      }
      .item_cont {
        color: #595757;
        line-height: 1.8;
      }
    }
  }
}
@media (min-width: 768px) {
  .caree_list {
    li {
      &:nth-child(2n) {
        .item {
          flex-direction: row-reverse;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .caree_list li .item_info {
    padding: 20px 15px;
  }
  .sec_type {
    margin-bottom: 15px;
    h3 {
      margin-bottom: 10px;
    }
  }
}
</style>
